// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".references_slider_module-layout {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 28px; }\n  .references_slider_module-layout .container-rating-card {\n    width: 100%; }\n  .references_slider_module-layout .container-item-slider {\n    width: calc(100% - 20px) !important; }\n", ""]);
// Exports
module.exports = exports;
